export function createInitialTurnOrder(playerCount: number): readonly number[] {
  return Array.from({ length: playerCount }, (_, i) => i);
}

export function calculateNextTurnOrder(
  currentOrder: readonly number[],
  forfeitPlayerIndex: number | null,
): readonly number[] {
  // Official: the start player rotates each round (the last-player card passes
  // left). With no forfeit, the next player in order leads and the old start
  // becomes the last player.
  if (forfeitPlayerIndex === null) {
    return [...currentOrder.slice(1), currentOrder[0]];
  }

  // A forfeiter becomes the last player; the seat after them leads next round.
  const pos = currentOrder.indexOf(forfeitPlayerIndex);
  if (pos === -1) {
    return currentOrder;
  }
  return [
    ...currentOrder.slice(pos + 1),
    ...currentOrder.slice(0, pos),
    forfeitPlayerIndex,
  ];
}
